module.exports = __webpack_public_path__ + "img/logo.843f1918.png";